// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.iconLayout_z0fTh {
  display: grid;
  grid-auto-flow: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-align: var( --textIconAlign, center );
      -ms-flex-align: var( --textIconAlign, center );
          align-items: var( --textIconAlign, center );
  -webkit-box-pack : start;
      -ms-flex-pack : start;
          justify-content : start;
  grid-column-gap: 8px;
  grid-column-gap: var( --textIconGap, 8px );
  -webkit-column-gap: 8px;
     -moz-column-gap: 8px;
          column-gap: 8px;
  -webkit-column-gap: var( --textIconGap, 8px );
     -moz-column-gap: var( --textIconGap, 8px );
          column-gap: var( --textIconGap, 8px );
}

.ellipsis_pgwiA {
  /* display : block; */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Text.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAA2C;MAA3C,sBAA2C;UAA3C,mBAA2C;EAA3C,iDAA2C;MAA3C,8CAA2C;UAA3C,2CAA2C;EAC3C,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oBAAqC;EAArC,0CAAqC;EAArC,uBAAqC;KAArC,oBAAqC;UAArC,eAAqC;EAArC,6CAAqC;KAArC,0CAAqC;UAArC,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["\n.iconLayout {\n  display: grid;\n  grid-auto-flow: column;\n  align-items: var( --textIconAlign, center );\n  justify-content : start;\n  column-gap: var( --textIconGap, 8px );\n}\n\n.ellipsis {\n  /* display : block; */\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconLayout": `iconLayout_z0fTh`,
	"ellipsis": `ellipsis_pgwiA`
};
export default ___CSS_LOADER_EXPORT___;
